export const getStripeEventPipelineHealth = `
   query getStripeEventPipelineHealth($windowStart: AWSDateTime!, $windowEnd: AWSDateTime!) {
       getStripeEventPipelineHealth(windowStart: $windowStart, windowEnd: $windowEnd) {
           windowStart
           windowEnd
           windowCapped
           periodSeconds
           buses {
               eventBusName
               eventBusArn
               observability
               observabilityLabel
               eventsReceived
               rules {
                   ruleName
                   ruleArn
                   state
                   startsStateMachine
                   matchedEvents
                   triggeredRules
                   invocations
                   failedInvocations
                   deadLetterInvocations
               }
           }
           stateMachine {
               stateMachineArn
               executionsStarted
               executionsSucceeded
               executionsFailed
               executionsTimedOut
               executionsAborted
           }
       }
   }
`;
